import React from 'react';
import styled from 'styled-components';
import { DatePicker } from 'antd';
import { CalendarTodayOutlined } from '@material-ui/icons';
import { BORDER } from '../../AnalyticsV2.styled';

// Calendar icon on the left, as in the design. antd always draws its own
// calendar icon on the right, so that one is hidden below.
const DateBox = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const CalendarIcon = styled(CalendarTodayOutlined)`
  &.MuiSvgIcon-root {
    position: absolute;
    left: 16px;
    z-index: 1;
    font-size: 20px;
    color: #1c1c1c;
    /* clicks go through to the picker, so the icon also opens it */
    pointer-events: none;
  }
`;

const RangePicker = styled(DatePicker.RangePicker)`
  &.ant-picker {
    height: 44px;
    padding: 0 30px 0 48px;
    border-radius: 8px;
    border-color: ${BORDER};
  }
  .ant-picker-input {
    flex: 0 0 auto;
    width: 104px;
  }
  .ant-picker-input > input {
    font-family: inherit;
    font-size: 15px;
    color: #1c1c1c;
  }
  .ant-picker-range-separator {
    padding: 0 6px;
    font-size: 15px;
    color: #1c1c1c;
  }
  .ant-picker-suffix {
    display: none;
  }
`;

// antd RangePicker reading "Jul 14, 2025 - Aug 14, 2026". Other props
// (disabled, disabledDate, onCalendarChange) go to the picker.
const DateRange = ({ value, onChange, ...pickerProps }) => (
  <DateBox>
    <CalendarIcon />
    <RangePicker
      value={value}
      onChange={onChange}
      format="MMM D, YYYY"
      separator="-"
      allowClear
      {...pickerProps}
    />
  </DateBox>
);

export default DateRange;
